import gql from 'graphql-tag';

export const listAllUsers = gql`
 query listAllUsers{
    listAllUsers{
      id
      username
      email
      businessName
      role
      mobile
      active
      confirmed
      createdAt
      wallet{ 
          id
          balance
          balanceTDC
      }
      stores{
        id
        name
      }
      deactivationReason
      deleteAccount
    }
  }
`;
